import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n'

import adminAppointment from './modules/adminAppointment'
import announcement from './modules/announcement'
import adminAppointmentFiles from './modules/adminAppointmentFiles'
import appointment from './modules/appointment'
import appointmentFiles from './modules/appointmentFiles'
import appointmentForm from './modules/appointmentForm'
import answer from './modules/answer'
import availableBalance from './modules/availableBalance'
import board from './modules/board'
import branches from './modules/branches'
import city from './modules/city'
import state from './modules/state'
import customer from './modules/customer'
import contract from './modules/contract'
import dashboard from './modules/dashboard'
import defaultServiceValues from './modules/defaultServiceValues'
import defaultServiceValuesForm from './modules/defaultServiceValuesForm'
import devolus from './modules/devolus'
import drawer from './modules/drawer'
import financial from './modules/financial'
import filters from './modules/filters'
import integration from './modules/integration'
import loading from './modules/loading'
import mission from './modules/mission'
import modal from './modules/modal'
import movement from './modules/movement'
import onboarding from './modules/onboarding'
import paginate from './modules/paginate'
import realEstate from './modules/realEstate'
import realEstateUsers from './modules/realEstateUsers'
import realty from './modules/realty'
import recharge from './modules/recharge'
import rechargeAdmin from './modules/rechargeAdmin'
import rechargeForm from './modules/rechargeForm'
import report from './modules/report'
import sales from './modules/sales'
import toaster from './modules/toaster'
import transfer from './modules/transfer'
import user from './modules/user'
import service from './modules/service'
import host from './modules/host'
import questionnaire from './modules/questionnaire'
import question from './modules/question'
import hostOnboarding from './modules/hostOnboarding'
import payment from './modules/payment'
import hostInvoice from './modules/hostInvoice'
import serviceReport from './modules/serviceReport'
import tag from './modules/tag'
import appointmentOfferPause from './modules/appointmentOfferPause'
import checklistTypes from './modules/appointmentChecklistLinksStore'
import adminAppointmentChangeStatus from './modules/adminAppointmentChangeStatus'
import webAppointmentChangeStatus from './modules/webAppointmentChangeStatus'

// new imports from view
import items from '@/views/item/itemStore'
import priceTable from '@/views/priceTable/priceTableStore'
import invoices from '@/views/invoices/hauseful/invoiceStore'
import categories from '@/views/category/categoryStore'
import itemPrice from '@/views/itemPrice/itemPriceStore'
import vendors from '@/views/vendor/vendorStore'
import splits from '@/views/split/splitStore'
import quote from '@/views/quote/quoteStore'
import partner from '@/views/partner/partnerStore'
import charge from '@/views/charge/chargeStore'
import hausefulUsers from '@/views/hausefulUsers/hausefulUsersStore'
import chargeAdmin from '@/views/charge/adminChargeStore'
import hostRating from '@/views/hostRating/hostRatingStore'
import qaAppointmentDashboard from '@/views/appointmentDashboard/appointmentDashboardStore'
import serviceProvider from '@/views/serviceProvider/serviceProviderStore'

import adminInvoiceStore from '@/views/invoices/admin/adminInvoiceStore'
import customerInvoiceStore from '@/views/invoices/customer/customerInvoiceStore'
import hostUserInvoices from '@/views/invoices/host/hostInvoiceStore'
import disputeStore from '@/views/dispute/disputeStore'
import divergenceStore from '@/views/divergence/divergenceStore'
import companies from '@/views/company/companyStore'
import financialReport from '@/views/financialReport/financialReportStore'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    adminAppointment,
    announcement,
    adminAppointmentFiles,
    appointment,
    appointmentFiles,
    appointmentForm,
    answer,
    availableBalance,
    board,
    branches,
    city,
    contract,
    state,
    customer,
    dashboard,
    defaultServiceValues,
    defaultServiceValuesForm,
    devolus,
    drawer,
    filters,
    financial,
    integration,
    loading,
    mission,
    modal,
    movement,
    onboarding,
    paginate,
    realEstate,
    realEstateUsers,
    realty,
    recharge,
    rechargeAdmin,
    rechargeForm,
    report,
    sales,
    service,
    toaster,
    transfer,
    user,
    host,
    questionnaire,
    invoices,
    hostOnboarding,
    categories,
    items,
    priceTable,
    itemPrice,
    vendors,
    payment,
    hostInvoice,
    splits,
    quote,
    serviceReport,
    question,
    partner,
    hausefulUsers,
    charge,
    chargeAdmin,
    hostRating,
    qaAppointmentDashboard,
    tag,
    serviceProvider,
    adminInvoiceStore,
    hostUserInvoices,
    customerInvoiceStore,
    appointmentOfferPause,
    checklistTypes,
    disputeStore,
    divergenceStore,
    companies,
    adminAppointmentChangeStatus,
    webAppointmentChangeStatus,
    financialReport,
  },
})

Vue.use(VuexI18n.plugin, store)

export default store
